const subServiceContent = {
  ipCommercial: {
    title: "IP Commercialization & Tech Transfer ",
    subtitle: "Unlock the True Value of Innovation",
    description:
      "Understanding the real worth of your intellectual property is key to making informed business decisions, attracting investment, and unlocking commercial opportunities. LifeIntelect delivers deep, data-driven valuation and technology transfer services that guide stakeholders through the complexities of IP monetization, risk analysis, and strategic deployment.",

    service_1: {
      title: "IP Valuation Services",
      subtitle: "Reveal Worth. Maximize Impact.",
      description:
        "Whether for licensing, fundraising, Merger & Acquisition, or strategic planning, knowing your IP’s financial value transforms it from a legal asset into a business enabler.",
      processTitle: "Key Valuation Deliverables:",
      process: [
        {
          title: "Multi-method Valuation:",
          description:
            "Cost-based, income-based, and market-based models applied for robust financial insight",
        },
        {
          title: "Asset-Level Intelligence:",
          description:
            "Legal, technical, and commercial evaluation of each IP component",
        },
        {
          title: "Strategic Valuation Reports",
          description:
            "Tailored for licensing, investment, financial disclosure, or tech transfer purposes",
        },
        {
          title: "Risk & Opportunity Mapping: ",
          description:
            "Identification of vulnerabilities and value drivers across your IP portfolio",
        },
      ],
      closing:
        "Turn your IP into a powerful lever for negotiation, investment, and growth.",
    },

    service_2: {
      title: "Patent Valuation Reports",
      subtitle: "Quantify Potential. Justify Investment.",
      description:
        "A well-structured valuation report supports deal-making and technology transfers by delivering credible, defensible asset appraisals.",

      processTitle: "Valuation Components Include:",
      process: [
        {
          title: "Intrinsic Valuation Models: ",
          description:
            "Deep analysis using cost, income, and market comparisons",
        },
        {
          title: "Monetization Pathways",
          description:
            "Licensing potential, royalty forecasting, and acquisition interest",
        },
        {
          title: "Market Alignment: ",
          description:
            "Demand forecasting, trend analysis, and fit within competitive ecosystems",
        },
        {
          title: "Regulatory & IP Risk Review",
          description:
            "Assessment of enforceability, challenges, and compliance",
        },
      ],
      closing:
        "Stakeholders gain clear, actionable insight to support high-stakes IP decisions.",
    },
    service_3: {
      title: "Patent Landscaping Reports",
      subtitle: "Position Technologies. Navigate Markets.",
      description:
        "A comprehensive look at the IP landscape helps innovators and investors understand where technologies stand—and where they can lead.",

      processTitle: "Strategic Insights Include:",
      process: [
        {
          title: "Patent Mapping",
          description:
            "Identification of overlapping technologies, trends, and whitespace",
        },
        {
          title: "Competitive Analysis",
          description:
            "Profiles of key players, potential partners, and threats",
        },
        {
          title: "Novelty & Non-Obviousness Review",
          description: "Assessment of differentiation in current IP ecosystems",
        },
        {
          title: "Commercial Fit",
          description:
            "Technology-to-market alignment and infringement risk detection",
        },
      ],
      closing:
        " Empower your technology with insights that clarify its path to market.",
    },
    service_4: {
      title: "Patent Due Diligence & Variability Analysis",
      subtitle: "Validate Strength. Secure Position.",
      description:
        "Before entering deals or scaling innovation, understanding a patent's legal and commercial robustness is essential.",
      processTitle: "Due Diligence Coverage:",
      process: [
        {
          title: "Validity & Prior Art Checks",
          description:
            "Rigorous searches to confirm novelty, utility, and enforceability",
        },
        {
          title: "Legal Status & Ownership Clarity",
          description:
            "Verification of current ownership, oppositions, and encumbrances",
        },
        {
          title: "Claim Strength Analysis: ",
          description:
            "Examination of scope, protection breadth, and freedom-to-operate",
        },
        {
          title: "Technology Adaptability",
          description:
            "Review of cross-domain application potential and integration feasibility",
        },
      ],
      closing:
        "Confidence in your IP starts with knowing it can stand up in court—and in the market",
    },
    service_5: {
      title: "Technology Transfer Services",
      subtitle: "From Innovation to Commercialization.",
      description:
        "Moving innovation from lab to market requires more than just patents—it demands strategic alignment, negotiation, and execution.",
      processTitle: "End-to-End Transfer Strategy:",
      process: [
        {
          title: "Tech Identification & Evaluation",
          description:
            "Assessment of readiness, market potential, and technical scalability",
        },
        {
          title: "Partner Discovery",
          description:
            "Matchmaking with licensees, buyers, or co-development allies",
        },
        {
          title: "Negotiation & Legal Frameworks: ",
          description: "Contract structuring and licensing documentation",
        },
        {
          title: "Market Positioning & Value Propositions",
          description: "Tailored messaging for commercial uptake",
        },
      ],
      closing:
        "Successful transfer lies in pairing the right opportunity with the right partner—at the right time.",
    },
    service_6: {
      title: "Post-Transfer Support",
      subtitle: "Ensure Seamless Integration. Build Long-Term Value.",
      description:
        "After the deal, continued engagement ensures a smooth transition and protects the integrity of the technology.",
      processTitle: "Ongoing Support Includes:",
      process: [
        {
          description:
            "Training for licensees and acquirers to integrate IP effectively",
        },
        {
          description:
            "Troubleshooting and assistance during operational adoption",
        },
        {
          description:
            "Relationship management to preserve long-term trust and collaboration",
        },
      ],
      closing:
        "Technology transfer doesn’t end with a signature—it begins a partnership",
    },
    subServices: {
      postTransfer: {
        title: "Post-Transfer Support",
        subHeading: "Post-Transfer Support",
        subTitle: "Ensure Seamless Integration. Build Long-Term Value.",
        description:
          "After the deal, continued engagement ensures a smooth transition and protects the integrity of the technology.",
        processTitle: "Ongoing Support Includes:",
        process: [
          {
            description:
              "Training for licensees and acquirers to integrate IP effectively",
          },
          {
            description:
              "Troubleshooting and assistance during operational adoption",
          },
          {
            description:
              "Relationship management to preserve long-term trust and collaboration",
          },
        ],
        closing:
          "Technology transfer doesn’t end with a signature—it begins a partnership",
      },
    },
  },
};

export default subServiceContent;
